// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Chamados_NaoLidosResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Resposta de GET /chamados/nao-lidos — o contador do sino.
 *
 * UM NÚMERO, e nada mais. Este endpoint é consultado a cada minuto por usuário
 * logado; devolver as linhas faria o filtro e a serialização rodarem por
 * minuto por pessoa, que é exatamente como um contador barato vira carga.
 *
 * Quem quiser a lista chama `/chamados/lista`, que já existe e é paginado —
 * e o faz UMA vez, quando a pessoa clica.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Chamados_NaoLidosResponseDados {
total: number
}

export type Chamados_NaoLidosResponse = ApiResponse<Chamados_NaoLidosResponseDados>;

registerResponseContract('Chamados_NaoLidosResponse', {
  total: { type: 'number',  required: true },
})
